import PropTypes from 'prop-types';
import { useEffect, useState } from "react";
import { BiSolidEdit } from "react-icons/bi";
import { FaSave } from "react-icons/fa";
import { MdCancel } from "react-icons/md";
import { useDispatch, useSelector } from "react-redux";
import DragAndDropContext from "../../../../app/common-components/DragAndDrop/DragDropContext";
import { PolicyCategorizationTabs } from "../../../../app/common-components/DragAndDrop/helpers.js";
import SearchInput from "../../../../app/common-components/SearchInput/SearchInput.jsx";
import Spinners from "../../../../app/common-components/Spinner.jsx";
import { useCommonAlert } from "../../../../app/utilities/helpers.js";
import { policyCategorizationList, savePolicyCategorization } from './PolicyPriviledgeSlice.js';
import "./styles.css";




const PolicyPriviledge = () => {
  const { policyCatgorizeLoading } = useSelector(
    (state) => state.PolicyPriviledgeSliceAPI
  );

  let tabs = PolicyCategorizationTabs;
  const orderedData = {};

  const [payLoadArr, setPayLoadArr] = useState([]);
  const [draggedId, setDraggedId] = useState();
  const [sourceId, setSourceId] = useState();
  const [draggedObject, setDraggedObject] = useState([]); // To track the original color of the dragged item
  const [containers, setContainers] = useState(orderedData);
  const [containersCopy, setContainersCopy] = useState({});
  const [searchValue, setSearchValue] = useState("");
  const [changesMade, setChangesMade] = useState(false);
  const { callCommonAlert, hideCommonAlert } = useCommonAlert();
  console.log(containers, "containers");
  const dispatch = useDispatch();
  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = () => {
    dispatch(policyCategorizationList()).then((data) => {
      const reorderedObj = {
        Uncategorized: data?.payload?.Uncategorized,
        High: data?.payload?.High,
        Medium: data?.payload?.Medium,
        Low: data?.payload?.Low,
      };
      setContainers(reorderedObj);
      setContainersCopy(reorderedObj);
    });
  };

  const fetchSavePolicy = async (payload) => {
    try {
      await dispatch(savePolicyCategorization({ payload })).then((response) => {
        console.log(response);
        if (response.payload.statusCodeValue === 200) {
          callCommonAlert("success", response.payload.body);
          hideCommonAlert();
          setSearchValue("");
        } else if (response.payload.statusCodeValue === 400) {
          callCommonAlert("error", response.payload.body);
          hideCommonAlert();
        } else {
          callCommonAlert("error", "Something went wrong. Please try again.");
          hideCommonAlert();
        }
      });
      setDraggedObject([]);

      fetchData();
    } catch (error) {
      console.error("Error saving policy categorization:", error);
    }
  };

  const [isEditClicked, setIsEditClicked] = useState(false);
  const [selectedTabs, setSelectedTabs] = useState(["All"]);
  useEffect(() => {
    console.log("Updated containersCopy:", containersCopy);
  }, [containersCopy]);
  console.log(selectedTabs);
  const getTotalLenght = () => {
    let count = 0;
    Object.keys(containers).forEach((key) => {
  const list = containers[key];
  if (Array.isArray(list)) {
    list.forEach(() => {
      count += 1;
    });
  }
});

    return count;
  };

  const handleTabClick = (tabName) => {
    if (tabName === "All") {
      setSelectedTabs(["All"]);
    } else {
      const newSelectedTabs = selectedTabs.includes(tabName)
        ? selectedTabs.filter((tab) => tab !== tabName)
        : [...selectedTabs.filter((tab) => tab !== "All"), tabName];
      if (newSelectedTabs.length === 4 || newSelectedTabs.length === 0) {
        setSelectedTabs(["All"]);
      } else {
        setSelectedTabs(newSelectedTabs);
      }
    }
  };

  useEffect(() => {
    searchFunction(searchValue);
  }, [selectedTabs]);

  const isTabSelected = (tabName) => selectedTabs.includes(tabName);

  const filteredContainers = Object.keys(containers).reduce((acc, key) => {
    if (selectedTabs.includes(key) || selectedTabs.includes("All")) {
      acc[key] = containers[key];
    }
    return acc;
  }, {});

  const getPayLoad = (dropId, dragId) => {
    const dragIdStr = dragId.toString();

    const currentGroup = payLoadArr.find((item) =>
      item.ids.includes(dragIdStr)
    );
    const currentSeverity = currentGroup?.severity;

    if (currentSeverity === dropId) {
      return payLoadArr;
    }

    let updatedArr = payLoadArr.map((item) => ({
      ...item,
      ids: item.ids.filter((id) => id.toString() !== dragIdStr),
    }));

    const dropIndex = updatedArr.findIndex((item) => item.severity === dropId);
    if (dropIndex !== -1) {
      updatedArr[dropIndex].ids.push(dragIdStr);
    } else {
      updatedArr.push({ severity: dropId, ids: [dragIdStr] });
    }

    setPayLoadArr(updatedArr);
    return updatedArr;
  };

  const onDragEnd = (result) => {
    if (!isEditClicked) {
      return;
    }

    const { source, destination, draggableId } = result;
    console.log(
      "source",
      source,
      "destination",
      destination,
      "draggableId",
      draggableId
    );
    if (
      !selectedTabs.includes(destination.droppableId) &&
      !selectedTabs.includes("All")
    ) {
      return null;
    }

    const payload = getPayLoad(destination.droppableId, draggableId);

    if (!destination) {
      return;
    }

    if (
      source.droppableId === destination.droppableId &&
      source.index === destination.index
    ) {
      return;
    }
    setDraggedId(draggableId);
    setSourceId(source.droppableId);
    const draggedObject = {
      id: draggableId,
      sourceId: source.droppableId,
    };

    setDraggedObject((prevState) => [...prevState, draggedObject]);

    const start = containers[source.droppableId];
    const finish = containers[destination.droppableId];

    if (source.droppableId === destination.droppableId) {
      const newItems = Array.from(start);
      const [movedItem] = newItems.splice(source.index, 1);
      newItems.splice(destination.index, 0, movedItem);

      setContainers((prevContainers) => ({
        ...prevContainers,
        [source.droppableId]: newItems,
      }));
    } else {
      const startItems = Array.from(start);
      const finishItems = Array.from(finish);
      const [movedItem] = startItems.splice(source.index, 1);

      finishItems.splice(destination.index, 0, movedItem);
      setContainers((prevContainers) => ({
        ...prevContainers,
        [source.droppableId]: startItems,
        [destination.droppableId]: finishItems,
      }));
      setChangesMade(true);
      setContainersCopy((prevContainersCopy) => ({
        ...prevContainersCopy,
        [source.droppableId]: startItems,
        [destination.droppableId]: finishItems,
      }));
    }
  };

  const enableEdit = () => {
    setIsEditClicked(true);
  };

  const disabelEdit = () => {
    setIsEditClicked(false);
    setChangesMade(false);
    fetchSavePolicy(payLoadArr);
  };

  const cancelEdit = () => {
    setIsEditClicked(false);
  };

  const getbordercolor = (containerName) => {
    const tab = tabs.find((tab) => tab.name === containerName);
    return tab ? tab.Bordercolor : "#ccc";
  };
  const getBackgroundColor = (containerName) => {
    const tab = tabs.find((tab) => tab.name === containerName);
    return tab ? tab.BackgroundColor : "#ccc";
  };

  const filteredContainer = {
    High: [],
    Medium: [],
    Low: [],
    Uncategorized: [],
  };

  let getSearchVal;
  const searchEnter = () => {};
  const handleOnSearch = (event) => {
    getSearchVal = event.target.value;
    const getSearchValue = getSearchVal?.trimStart();
    setSearchValue(getSearchValue);
    searchFunction(getSearchValue);
  };

  const searchFunction = (updatedValue) => {
    const filteredContainer = { ...containers };
    Object.keys(containersCopy).forEach((key) => {
      if (selectedTabs.includes("All")) {
        const filtered = containersCopy[key].filter((policy) =>
          policy.policyName.toLowerCase().includes(updatedValue.toLowerCase())
        );
        filteredContainer[key] = filtered;
      } else {
        if (selectedTabs.includes(key)) {
          const filtered = containersCopy[key].filter((policy) =>
            policy.policyName.toLowerCase().includes(updatedValue.toLowerCase())
          );
          filteredContainer[key] = filtered;
        } else {
          filteredContainer[key] = containersCopy[key];
        }
      }
    });
    setContainers(filteredContainer);
  };

  const changeFunc = (id, severity) => {
    getPayLoad("Uncategorized", id, true);

    const canceledObject = {
      id: id,
      sourceId: severity,
    };

    setDraggedObject((prevState) => [...prevState, canceledObject]);

    setContainers((prevContainers) => {
      const updatedContainers = { ...prevContainers };

      if (!updatedContainers.hasOwnProperty("Uncategorized")) {
        updatedContainers["Uncategorized"] = [];
      }

      const updatedValItems = [...updatedContainers[severity]];

      const itemIndex = updatedValItems.findIndex((item) => item.id === id);

      if (itemIndex === -1) {
        console.error(`Item with id ${id} not found in ${severity}`);
        return prevContainers;
      }
      console.log(itemIndex);
      const [movedItem] = updatedValItems.splice(itemIndex, 1);

      updatedContainers[severity] = updatedValItems;
      updatedContainers["Uncategorized"] = [
        movedItem,
        ...updatedContainers["Uncategorized"],
      ];
      setContainersCopy((prevContainersCopy) => ({
        ...prevContainersCopy,

        [severity]: updatedValItems,

        Uncategorized: [movedItem, ...prevContainersCopy.Uncategorized],
      }));
      setChangesMade(true);

      return updatedContainers;
    });

    console.log(`Moved item ${id} from ${severity} to 'Uncategorized'`);
  };

  console.log(tabs);
  const isDisabled = (selectedTabs) => {
    return !(
      Array.isArray(selectedTabs) &&
      selectedTabs.length === 1 &&
      selectedTabs[0] === "All"
    );
  };

  return (
    <div className="policy-head">
      <div className="policyTab-part">
        <div>
          {tabs.map((tab) => (
            <button
              key={tab.name}
              className="uar-tab"
              data-testid={`tabButton_${tab.name}`}
              onClick={() => handleTabClick(tab.name)}
              style={{
                border: `2px solid ${tab.Bordercolor}`,
                color: "black",
                marginRight: "5px",
                boxShadow: "0 3px 10px rgb(0 0 0 / 0.2)",
                opacity: isTabSelected(tab.name) ? 1 : 0.4,
                letterSpacing: "0.5px",
                textAlign: "center",
                backgroundColor:
                  tab.name === "Uncategorized"
                    ? "#edf2f5"
                    : tab.name === "High"
                    ? "#f5e4e4"
                    : tab.name === "Medium"
                    ? "#f5e8d0"
                    : tab.name === "Low"
                    ? "#f7f7c8"
                    : "#c6caf7",
              }}
            >
              <h1 className="uar-tab-name">
                {tab.name === "All"
                  ? `${tab.name} (${getTotalLenght()})`
                  : tab.name === "Uncategorized"
                  ? `${tab.name} (${containers[tab.name]?.length || 0})`
                  : `${tab.name} ${"Risk"} (${
                      containers[tab.name]?.length || 0
                    })`}
              </h1>
            </button>
          ))}
        </div>
        <div style={{ display: "flex", flexDirection: "row" }}>
          <div>
            {changesMade ? (
              <button
                type="button"
                onClick={disabelEdit}
                className="drag-save-button"
                data-testid="save-policy-privilege-button"
              >
                <FaSave className="icon-drag-drop" />
                <p className="edit-related-btn">Save</p>
              </button>
            ) : isEditClicked ? (
              <button
                type="button"
                onClick={cancelEdit}
                className="drag-save-button"
                data-testid="cancel-policy-privilege-button"
              >
                <MdCancel className="icon-drag-drop" />
                <p className="edit-related-btn">Cancel</p>
              </button>
            ) : (
              <button
                type="button"
                onClick={enableEdit}
                className="drag-edit-btn"
                data-testid="editButton"
                disabled={isDisabled(selectedTabs)}
              >
                <BiSolidEdit className="icon-drag-drop" />
                <p className="edit-related-btn">Edit</p>
              </button>
            )}
          </div>
          <div className="d-flex">
            <SearchInput
              searchInputValue={searchValue}
              handleOnSearch={handleOnSearch}
              handleSearchClick={searchEnter}
            />
          </div>
        </div>
      </div>
      {/* <hr className="hr-el" /> */}
      {policyCatgorizeLoading || containers.lenght === 0 ? (
        <Spinners />
      ) : (
        <DragAndDropContext
          isLoading={policyCatgorizeLoading}
          TopContainers={["Uncategorized"]}
          isNoDataMsg={"No Policy Available"}
          nameSuffix={"Risk"}
          nonRemovableTabs={["Uncategorized", "Active"]}
          tabs={tabs}
          containers={containers}
          onDragEnd={onDragEnd}
          getbordercolor={getbordercolor}
          getBackgroundColor={getBackgroundColor}
          isTabSelected={isTabSelected}
          changeFunc={changeFunc}
          isEditClicked={isEditClicked}
          selectedTabs={selectedTabs}
          draggedId={draggedId}
          sourceId={sourceId}
          draggedObject={draggedObject}
        />
      )}
    </div>
  );
};

export default PolicyPriviledge;
PolicyPriviledge.propTypes = {
  payLoadArr: PropTypes.arrayOf(
    PropTypes.shape({
      severity: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
        .isRequired,
      ids: PropTypes.arrayOf(PropTypes.string).isRequired,
    })
  ).isRequired,
  setPayLoadArr: PropTypes.func.isRequired,
};
